import React from "react";
import { FadeIn } from "../atoms/FadeIn";
import { SectionFrame } from "../atoms/SectionFrame";
import { MorphWords } from "../atoms/WordCycles";
import { TID } from "../../lib/testIds";

const INDUSTRIES = [
    "AI STARTUPS",
    "SAAS",
    "UNIVERSITIES",
    "ENTERPRISE",
    "HR",
    "CORPORATE LEARNING",
];

export function BuiltForSection() {
    return (
        <SectionFrame innerClassName="">
            <div className="py-28 md:py-44 px-6 md:px-12 text-center">
                <div className="text-base sm:text-base uppercase tracking-[0.3em] mb-6 md:mb-8"
                     style={{ color: "var(--accent)" }}>
                    BUILT FOR
                </div>
                <h3
                    className="font-black uppercase"
                    style={{
                        fontSize: "clamp(2.5rem, 9vw, 7rem)",
                        lineHeight: 1.05,
                        letterSpacing: "-0.03em",
                    }}
                >
                    <MorphWords
                        words={INDUSTRIES}
                        interval={2800}
                        data-testid={TID.builtForMorph}
                    />
                </h3>
                <FadeIn delay={0.2} y={20} className="mt-10 md:mt-14">
                    <p
                        data-testid={TID.builtForTagline}
                        className="uppercase tracking-[0.25em]"
                        style={{
                            color: "var(--muted)",
                            fontSize: "clamp(0.85rem, 1.6vw, 1.25rem)",
                        }}
                    >
                        If it needs explaining, we&apos;re interested.
                    </p>
                </FadeIn>
            </div>
        </SectionFrame>
    );
}
